import React from "react";
import { Chip, Divider, Stack, Typography } from "@mui/material";
import { connect } from "react-redux";
import dayjs from "dayjs";

import { HubIcon, UserDetailIcon } from "../../components";
import { getDollarValue } from "../../helpers/currency";
import { setIsOpenDialog } from "../../redux";
import { LEAD_STAGE_LABELS } from "../../constants/salesStages";

import SalesContextMenu from "./SalesContextMenu";
import { StyledCard } from "./styles";

const LeadCard = ({
  id,
  companyName,
  contactName,
  value,
  assignee,
  customer,
  stage,
  createdAt,
  _setIsOpenDialog = () => {},
}) => {
  const name = companyName || customer?.name || "Unnamed";
  const stageInfo = LEAD_STAGE_LABELS.find((s) => s.id === stage);

  return (
    <StyledCard onClick={() => _setIsOpenDialog("edit-lead", Number(id))}>
      <Stack direction="row" justifyContent="space-between" alignItems="start">
        <Stack>
          <Typography variant="boldCaptionL" fontSize={14} noWrap>
            {name}
          </Typography>
          {contactName ? (
            <Typography variant="caption11" noWrap>
              {contactName}
            </Typography>
          ) : (
            <Typography variant="caption11" color="hubColors.grey" noWrap>
              No Contact
            </Typography>
          )}
        </Stack>
        <SalesContextMenu itemId={id} type="lead" />
      </Stack>

      <Stack direction="row" gap="6px" alignItems="center">
        {value && (
          <Typography variant="caption11">{getDollarValue(value)}</Typography>
        )}
        {value && createdAt && (
          <Typography variant="caption" lineHeight="12px" fontSize={24} color="text.disabled">
            •
          </Typography>
        )}
        {createdAt && (
          <Stack direction="row" gap="4px" alignItems="center">
            <HubIcon icon="Calendar" size={11} />
            <Typography variant="caption11">
              {dayjs(createdAt).format("MMM D, YYYY")}
            </Typography>
          </Stack>
        )}
      </Stack>

      <Divider />

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {assignee ? (
          <UserDetailIcon
            size={18}
            user={{ name: assignee.name, hueShift: assignee.id }}
            variant="rounded"
            includeName={assignee.name}
          />
        ) : (
          <Typography variant="caption" fontSize={10} color="text.disabled">
            Unassigned
          </Typography>
        )}
        {stageInfo && (
          <Chip
            variant="colorTag"
            flow={stageInfo.flow}
            label={stageInfo.label}
            size="small"
            sx={{ fontSize: 10 }}
          />
        )}
      </Stack>
    </StyledCard>
  );
};

const mapDispatchToProps = { _setIsOpenDialog: setIsOpenDialog };
export default connect(null, mapDispatchToProps)(LeadCard);
